import { AppConstants } from "src/app/common/constants/app-constants";

export type Severity = "Standard" | "Warning" | "Severe";

export const SEVERITY_BY_ID: Record<number, Severity> = {
  1: "Standard",
  2: "Warning",
  3: "Severe",
};

export const SEVERITY_ORDER: Record<Severity, number> = {
  Severe: 0,
  Warning: 1,
  Standard: 2,
};

export const SEVERITY_STYLES: Record<
  Severity,
  { bannerClass: string; badgeClass: string; label: string }
> = {
  Severe: {
    bannerClass: "announcement-banner-severe",
    badgeClass: "announcement-badge-severe",
    label: "Severe",
  },
  Warning: {
    bannerClass: "announcement-banner-warning",
    badgeClass: "announcement-badge-warning",
    label: "Warning",
  },
  Standard: {
    bannerClass: "announcement-banner-standard",
    badgeClass: "announcement-badge-standard",
    label: "Standard",
  },
};

export const DISMISSALS_KEY = "rc_announcement_dismissals_v1";
export const MAX_VISIBLE_BANNERS = 2;
export const CONTENT_PREVIEW_MAX = 140;

/** All user-facing copy for the banner/bell/slideout — kept out of the
 * template so there's one place to change wording, and so any string
 * that's already shared app-wide (e.g. "Close") is reused from AppConstants
 * instead of being redefined here. */
export const ANNOUNCEMENT_BANNER_TEXT = {
  regionLabel: "Announcements",
  slideoutTitle: "Announcements",
  bellLabel: "View all announcements",
  dismissLabelPrefix: "Dismiss: ",
  dismiss: "Dismiss",
  noActiveAnnouncements: "No active announcements.",
  backToList: "All announcements",
  dontShowAgain: "Don't show again",
  close: AppConstants.close,
  moreAnnouncement: "more announcement",
};
